function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { EdgeDetection } from 'xps-react-utils';

var DropdownPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownPanel, _React$Component);

  var _super = _createSuper(DropdownPanel);

  function DropdownPanel(props) {
    var _this;

    _classCallCheck(this, DropdownPanel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleVerticalOverFlow", function () {
      var _this$props = _this.props,
          dropUp = _this$props.dropUp,
          dynamicDropDirection = _this$props.dynamicDropDirection,
          dropdownPanelRef = _this$props.dropdownPanelRef;

      if (dynamicDropDirection && dropdownPanelRef.current && // eslint-disable-next-line react/destructuring-assignment
      _this.state.dropUp === dropUp // Indicates the drop direction was unchanged since the dropdown was opened.
      ) {
        var overflows = EdgeDetection.detect(EdgeDetection.getDimensions(dropdownPanelRef.current), EdgeDetection.getWindowDimensions());

        for (var i = 0; i < overflows.length; i += 1) {
          if (overflows[i].direction === 'bottom' || overflows[i].direction === 'top') {
            // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
            _this.setState({
              dropUp: !_this.state.dropUp
            });

            return;
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleHorizontalOverFlow", function () {
      var _this$props2 = _this.props,
          alignRight = _this$props2.alignRight,
          dynamicDropAlign = _this$props2.dynamicDropAlign,
          dropdownPanelRef = _this$props2.dropdownPanelRef;

      if (dynamicDropAlign && dropdownPanelRef.current && // eslint-disable-next-line react/destructuring-assignment
      _this.state.alignRight === alignRight // Indicates the alignment was unchanged since the dropdown was opened.
      ) {
        var overflows = EdgeDetection.detect(EdgeDetection.getDimensions(dropdownPanelRef.current), EdgeDetection.getWindowDimensions());

        for (var i = 0; i < overflows.length; i += 1) {
          if (overflows[i].direction === 'left' || overflows[i].direction === 'right') {
            // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
            _this.setState({
              alignRight: !_this.state.alignRight
            });

            return;
          }
        }
      }
    });

    var _this$props3 = _this.props,
        _alignRight = _this$props3.alignRight,
        _dropUp = _this$props3.dropUp;
    _this.state = {
      dropUp: _dropUp,
      alignRight: _alignRight
    };
    return _this;
  }

  _createClass(DropdownPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleVerticalOverFlow();
      this.handleHorizontalOverFlow();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleVerticalOverFlow();
      this.handleHorizontalOverFlow();
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props4 = this.props,
          className = _this$props4.className,
          isOpen = _this$props4.isOpen,
          width = _this$props4.width,
          height = _this$props4.height,
          children = _this$props4.children,
          fieldSize = _this$props4.fieldSize,
          dropdownPanelRef = _this$props4.dropdownPanelRef,
          noPadding = _this$props4.noPadding;
      var _this$state = this.state,
          alignRight = _this$state.alignRight,
          dropUp = _this$state.dropUp;
      var dropdownPanelClasses = classnames((_classnames = {
        dropdown__panel: true,
        'display-block': isOpen,
        'display-none': !isOpen,
        'dropdown__panel--right': alignRight
      }, _defineProperty(_classnames, "bottom-".concat(fieldSize), dropUp), _defineProperty(_classnames, 'overflowy-auto', true), _defineProperty(_classnames, 'paddingtop-md', !noPadding), _defineProperty(_classnames, 'paddingbottom-md', !noPadding), _defineProperty(_classnames, 'paddingleft-lg', !noPadding), _defineProperty(_classnames, 'paddingright-lg', !noPadding), _defineProperty(_classnames, 'padding-0', noPadding), _classnames), className);
      return /*#__PURE__*/React.createElement("div", {
        className: dropdownPanelClasses,
        style: {
          width: width,
          height: height
        },
        ref: dropdownPanelRef
      }, children);
    }
  }]);

  return DropdownPanel;
}(React.Component);

DropdownPanel.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alignRight: PropTypes.bool,
  dropUp: PropTypes.bool,
  dynamicDropAlign: PropTypes.bool,
  dynamicDropDirection: PropTypes.bool,
  fieldSize: PropTypes.oneOf(['large', 'medium', 'small']),
  dropdownPanelRef: PropTypes.object,
  noPadding: PropTypes.bool
};
DropdownPanel.defaultProps = {
  isOpen: false,
  alignRight: false,
  dropUp: false,
  dropdownPanelRef: React.createRef(),
  noPadding: false
};
DropdownPanel.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleVerticalOverFlow",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleHorizontalOverFlow",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "DropdownPanel",
  "props": {
    "isOpen": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "alignRight": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "dropUp": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "dropdownPanelRef": {
      "defaultValue": {
        "value": "React.createRef()",
        "computed": true
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "noPadding": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "width": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": ""
    },
    "height": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": ""
    },
    "dynamicDropAlign": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "dynamicDropDirection": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "fieldSize": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'large'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    }
  }
};
export default DropdownPanel;